import React from "react";
import cx from "classnames";
import { CrossThickIcon, ExpandIcon, FullScreenIcon } from "assets";
import { useTranslation } from "i18n";
import ProfileButton from "pages/Profile/components/common/ProfileButton";
import { dataTestIds } from "data-testids";

interface Props {
  isExpanded?: boolean;
  toggleClick: () => void;
  fullScreenClick: () => void;
  className?: string;
}

const SectionControl = ({
  isExpanded,
  toggleClick,
  fullScreenClick,
  className,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div
      className={cx(
        "absolute right-3 top-3 z-[1] flex gap-2 dark:text-white",
        className
      )}
    >
      <ProfileButton
        className={cx("rounded-full", {
          "lg:hidden": !isExpanded,
        })}
        onClick={fullScreenClick}
        aria-label={t("common:aria.label.openFullscreenView")}
        data-testid={
          dataTestIds.profile["Profile.SectionControl.FullScreenButton"]
        }
      >
        <FullScreenIcon
          className="text-white drop-shadow-profile"
          aria-hidden="true"
          focusable="false"
        />
      </ProfileButton>

      <ProfileButton
        className="hidden rounded-full lg:flex"
        onClick={toggleClick}
        aria-label={
          isExpanded
            ? t("common:aria.label.closeExpandedView")
            : t("common:aria.label.openExpandedView")
        }
        data-testid={
          dataTestIds.profile[
            isExpanded
              ? "Profile.SectionControl.CloseViewButton"
              : "Profile.SectionControl.ExpandedViewButton"
          ]
        }
      >
        {isExpanded ? (
          <CrossThickIcon
            className="text-white drop-shadow-profile"
            aria-hidden="true"
            focusable="false"
          />
        ) : (
          <ExpandIcon
            className="text-white drop-shadow-profile"
            aria-hidden="true"
            focusable="false"
          />
        )}
      </ProfileButton>
    </div>
  );
};

export default SectionControl;
